import { StatusCodes } from 'http-status-codes';

import { ErrorCodes } from '@reach/interfaces/error/error-codes.enum';

import { AppError } from '../error/app-error';
import { ensureAssert } from './ensure-assert';

export class UnexpectedNullOrUndefined extends AppError {
	constructor() {
		super({
			status: StatusCodes.INTERNAL_SERVER_ERROR,
			code: ErrorCodes.UTILS_UNEXPECTED_NULL_OR_UNDEFINED,
			title: 'Unexpected null or undefined value.',
		});
	}
}

export function ensure<T, A>(
	argument: T,
	errorFn?: (...args: A[]) => never,
	...errorArgs: A[]
): Exclude<T, undefined | null> {
	if (ensureAssert(argument)) {
		return argument;
	}
	if (ensureAssert(errorFn)) {
		errorFn(...errorArgs);
	}

	throw new UnexpectedNullOrUndefined();
}
